import { useState } from "react";

/**
 * State shared across the whole browse subtree (the sub-tab grids + the morpheme/search-card
 * detail pages). `parentBrowseTab` is the human-readable label of the browse surface the user
 * came from — the focused sub-tab title ("Levels" | "Characters" | "Primitives" | "Words") set
 * by `browse-tabs-layout` on tab change, or "Search" when the search-card detail is entered from
 * the search page. A non-tab-root detail page renders `<BrowseNavBackButton>` which reads this to
 * label its back control (e.g. a back button reading "Characters" that returns to the Characters
 * grid). Seeded to the initial sub-tab ("Levels"); the tab-focus listener overwrites it as soon as
 * a tab focuses, so the default only matters before any tab has focused.
 */
export function useBrowseLayoutContextValue() {
  const [parentBrowseTab, setParentBrowseTab] = useState("Levels");

  return {
    parentBrowseTab,
    setParentBrowseTab,
  };
}

export type BrowseLayoutContextValue = ReturnType<typeof useBrowseLayoutContextValue>;
